import { createContext, PropsWithChildren, useReducer } from "react";

import { CreateSourceWebhookAction } from "@/pages/sources/components/create/sources/webhook/actions";
import {
  DEFAULT_BATCH_INTERVAL_SECONDS,
  DEFAULT_BATCH_MAX_SIZE,
  DEFAULT_SIGNATURE_HEADER,
} from "@/pages/sources/components/create/sources/webhook/constants";
import createSourceWebhookReducer from "@/pages/sources/components/create/sources/webhook/reducer";
import {
  CreateSourceWebhookPhase,
  CreateSourceWebhookState,
} from "@/pages/sources/components/create/sources/webhook/types";

export interface CreateSourceWebhookContextShape {
  state: CreateSourceWebhookState;
  dispatch: React.Dispatch<CreateSourceWebhookAction>;
}

export const DEFAULT_STATE: CreateSourceWebhookState = {
  sourceName: "",
  phase: CreateSourceWebhookPhase.CONFIGURE,
  signatureHeader: DEFAULT_SIGNATURE_HEADER,
  batchIntervalSeconds: DEFAULT_BATCH_INTERVAL_SECONDS,
  batchMaxSize: DEFAULT_BATCH_MAX_SIZE,
  credentials: null,
  sourceId: null,
  error: null,
  shouldShowErrors: false,
};

export const CreateSourceWebhookContext = createContext<CreateSourceWebhookContextShape | null>(
  null,
);
CreateSourceWebhookContext.displayName = "CreateSourceWebhookContext";

const CreateSourceWebhookProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createSourceWebhookReducer, DEFAULT_STATE);

  return (
    <CreateSourceWebhookContext.Provider value={{ state, dispatch }}>
      {children}
    </CreateSourceWebhookContext.Provider>
  );
};

export default CreateSourceWebhookProvider;
